// extracted by mini-css-extract-plugin
module.exports = {"timeStart":"styles_timeStart__3EoEC","timeEnd":"styles_timeEnd__3nWsv"};